<template>
   <main id="event_body">
    <div class="myPost_wrapper" id="more_board">
      <!-- title -->
      <div class="main_top">
        <h1><img src ="images/basic/icon/back.svg" onclick="history.back()" class="back">
          이벤트 상세
        </h1>
      </div>
      <div class="div_padding"></div>
         <div>
    <div class="eventInfo_status">
      <div class="attendance">
        <p>
          이벤트 당첨자 <span>{{ listCnt }}명</span>
        </p>
        <div>
           <img src="images/basic/icon/close-b.svg" onclick="history.back()" alt="">
        </div>
      </div>
    </div>
    <table class="event_rank">
      <thead>
        <tr>
          <td>
            <p>순위</p>
          </td>
          <td>
            <p>닉네임(폰번호)</p>
            <p>참여시간</p>
          </td>
         <td>
          <p>선택번호</p>
        </td>
      </tr>
      </thead>
      <tbody>
        <winner-list-table-form v-for="(winner) in winnerList" :key="winner.userRank" :winner="winner" :lottoList="lottoList"></winner-list-table-form>
      </tbody>
    </table>
  </div>
    </div>
  </main>
</template>


<script>
import { fetchEventWinnerList } from '@/api/event'
import WinnerListTableForm from './WinnerListTableForm.vue'
export default {
  components: {
    WinnerListTableForm
  },
  created() {
    fetchEventWinnerList({
      nttId: this.$route.query.nttId,
      pageIndex: this.pageIndex,
      recordCntOnPage: 20
    })
    .then(({ data }) => {
      console.log(data);
      let result = data.eventInfo
      this.lottoList.push(`${result.num1}`, `${result.num2}`, `${result.num3}`, `${result.num4}`, `${result.num5}`, `${result.num6}`)
      this.listCnt = data.resultCnt;
      this.winnerList = data.resultList;
    })
  },
  mounted() {
    const offset = 10;
    window.addEventListener('scroll', () => { // scroll event 등록
        if(window.$(window).scrollTop() > ( window.$(document).height() - window.$(window).height()) - offset){
            this.fetchData();
        }
    });
  },
  data() {
    return {
      pageIndex: 1,
      listCnt: 0,
      winnerList: [],
      lottoList: [],
    }
  },
  methods: {
    fetchData() {
      if(this.winnerList.length < this.listCnt) {
        this.pageIndex += 1
        fetchEventWinnerList({
          nttId: this.$route.query.nttId,
          pageIndex: this.pageIndex,
          recordCntOnPage: 20
        })
        .then(({ data }) => {
          console.log(data);
          this.listCnt = data.resultCnt;
          this.winnerList = [...this.winnerList, ...data.resultList];
          this.winnerList.sort(function(a, b)  {
            return a.userRank - b.userRank;
          });
        
        })
      }
    }
  },

}
</script>

<style scoped>
table {
  width: 100%;
}

table thead {
  border-top: 1px solid #CDD2DA;
  border-bottom: 1px solid #CDD2DA;
  color: #9EA3AB;
  font-size: 12px;
  height: 53px;
}

table thead tr td {
  padding-top: 12px;
}

table thead tr td:nth-child(2) {
  text-align: left;
}

table thead tr td:nth-child(3), table tbody tr td:nth-child(3) {
  text-align: right;
  padding-right: 14px;
}

table thead tr td:nth-child(1), table tbody tr td:nth-child(1){
  text-align: center;
  min-width: 40px;
}

table tbody tr{
  font-size: 12px;
  height: 60px;
}

table tbody tr td {
  padding-top: 14px;
  border-bottom: 1px solid #CDD2DA;
}

table tbody tr td span {
  color: #9EA3AB;
}

table tfoot tr td div {
  padding: 30px;
  font-size: 14px;
}

.eventInfo_status {
  width: 100%;
  height: 60px;
  border-top: 1px solid rgba(37, 45, 58, 0.3);
}

.eventInfo_status .attendance {
  padding: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.eventInfo_status .attendance p{
  margin-top: 20px;
  margin-left: 20px;
}

.eventInfo_status .attendance p span {
  color: #FF7100;
  font-size: 16px;
}

.attendance div img {
  width: 14px;
}

.attendance div {
  margin-right: 20px;
  margin-top: 17px;
}

</style>